import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: ' 财务系统'
			}
		},
		{
			path: '/voucher',
			name: 'Voucher',
			component: () => import('./views/voucher/Index'),
			meta: {
				title: '凭证列表'
			}
		},
		{
			path: '/voucher/form/:voucherId(\\d+)?',
			name: 'VoucherForm',
			component: () => import('./views/voucher/VoucherForm'),
			props: true,
			meta: {
				title: '凭证信息'
			}
		},
		{
			path: '/check-out',
			name: 'CheckOut',
			component: () => import('./views/checkout/Index'),
			children: [
				{
					path: 'list',
					name: 'CheckList',
					component: () => import('./views/checkout/CheckList'),
					meta: {
						title: '结账'
					}
				},
				{
					path: 'un-check',
					name: 'UnCheckOut',
					component: () => import('./views/checkout/UnCheckOut'),
					meta: {
						title: '反结账'
					}
				}, {
					path: 'carry-forward/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'CarryForward',
					props: true,
					component: () => import('./views/checkout/CarryForward'),
					meta: {
						title: '月末结转'
					}
				}, {
					path: 'check/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'Check',
					props: true,
					component: () => import('./views/checkout/Check'),
					meta: {
						title: '检查'
					}
				}
			]
		},
		{
			path: '/salesdata',
			name: 'salesdata',
			component: () => import('./views/salesdata/Index'),
			children: [
				{
					path: 'Saleorder',
					name: 'Saleorder',
					component: () => import('./views/salesdata/Saleorder'),
					meta: {
						title: '订单管理'
					}
				},
				// {
				// 	path: 'Summary',
				// 	name: 'Summary',
				// 	component: () => import('./views/salesdata/Summary'),
				// 	meta: {
				// 		title: '销售汇总表'
				// 	}
				// },
				{
					path: 'Sellthrough',
					name: 'Sellthrough',
					component: () => import('./views/salesdata/Sellthrough'),
					meta: {
						title: '销售数据'
					}
				}
			]
		},
		{
			path: '/community',
			name: 'community',
			component: () => import('./views/community/Index'),
			children: [
				{
					path: 'SignCommunity',
					name: 'SignCommunity',
					component: () => import('./views/community/signCommunity'),
					meta: {
						title: '签约社区'
					}
				},
				{
					path: 'waiter',
					name: 'waiter',
					component: () => import('./views/community/waiter'),
					meta: {
						title: '生活服务人员'
					}
				},
				{
					path: 'waiterCashOut',
					name: 'waiterCashOut',
					component: () => import('./views/community/waiterCashOut'),
					meta: {
						title: '提现明细'
					}
				},
			]
		},
		{
			path: '/stores',
			name: 'stores',
			component: () => import('./views/stores/Index'),
			children: [
				{
					path: 'storeManage',
					name: 'storeManage',
					component: () => import('./views/stores/storeManage'),
					meta: {
						title: '门店列表'
					}
				}
			]
		},
		{
			path: '/propertys',
			name: 'propertys',
			component: () => import('./views/propertys/Index'),
			children: [ 
				{
					path: 'propertysCard',
					name: 'propertysCard',
					component: () => import('./views/propertys/propertysCard'),
					meta: {
						title: '资产卡片'
					}
				},
			]
		},
		{
			path: '/cashier',
			name: 'cashier',
			component: () => import('./views/cashier/Index'),
			children: [
				
				{
					path: 'CashDaily',
					name: 'CashDaily',
					component: () => import('./views/cashier/CashDaily'),
					meta: {
						title: '现金银行日记账'
					}
				},
				{
					path: 'Abstracts',
					name: 'Abstracts',
					component: () => import('./views/cashier/Abstracts'),
					meta: {
						title: '常用摘要'
					}
				},
				
				{
					path: 'Act',
					name: 'Act',
					component: () => import('./views/cashier/Act'),
					meta: {
						title: '账号'
					}
				},
				{
					path: 'SettlementType',
					name: 'SettlementType',
					component: () => import('./views/cashier/SettlementType'),
					meta: {
						title: '结算方式'
					}
				},
				{
					path: 'TradeType',
					name: 'TradeType',
					component: () => import('./views/cashier/TradeType'),
					meta: {
						title: '收支类型'
					}
				},
				{
					path: 'ReportFroms',
					name: 'ReportFroms',
					component: () => import('./views/cashier/ReportFroms'),
					meta: {
						title: '资金报表'
					}
				}
				 
			]
		},
		{
			path: '/wages',
			name: 'wages',
			component: () => import('./views/wages/Index'),
			children: [
				// {
				// 	path: 'salarymanage',
				// 	name: 'Salarymanage',
				// 	component: () => import('./views/wages/Salarymanage'),
				// 	meta: {
				// 		title: '工资管理'
				// 	}
				// },
				{
					path: 'salarymanage1',
					name: 'Salarymanage1',
					component: () => import('./views/wages/Salarymanage_1'),
					meta: {
						title: '工资管理'
					}
				},
				{
					path: 'employeeinfo',
					name: 'Employeeinfo',
					component: () => import('./views/wages/Employeeinfo'),
					meta: {
						title: '工资管理'
					}
				},
				{
					path: 'fiveone',
					name: 'Fiveone',
					component: () => import('./views/wages/Fiveone'),
					meta: {
						title: '五险一金'
					}
				}
			]
		},
		{
			path: '/account',
			name: 'Account',
			component: () => import('./views/setting/Account'),
			meta: {
				title: '账套'
			}
		},
		{
			path: '/subject',
			name: 'Subject',
			component: () => import('./views/setting/Subject'),
			meta: {
				title: '科目'
			}
		},
		{
			path: '/initial',
			name: 'Initial',
			component: () => import('./views/setting/Initial'),
			meta: {
				title: '期初'
			}
		},
		{
			path: '/voucher-word',
			name: 'VoucherWord',
			component: () => import('./views/setting/VoucherWord'),
			meta: {
				title: '凭证字'
			}
		},
		{
			path: '/currency',
			name: 'Currency',
			component: () => import('./views/setting/Currency'),
			meta: {
				title: '币别'
			}
		},
		{
			path: '/assisting-accounting',
			name: 'AssistingAccounting',
			component: () => import('./views/setting/AssistingAccounting'),
			meta: {
				title: '辅助核算'
			},
			children: [
				{
					path: 'accounting-category',
					name: 'AccountingCategory',
					component: () => import('./views/setting/AssistingAccounting/AccountingCategory'),
					meta: {
						title: '辅助核算类别'
					}
				},
				{
					path: 'custom/:id(\\d+)',
					name: 'CategoryCustom',
					component: () => import('./views/setting/AssistingAccounting/CategoryCustom'),
					props: true,
					meta: {
						title: '自定类别'
					}
				}
			]
		},
		{
			path: '/template',
			component: () => import('./views/setting/template/Index'),
			meta: {
				title: '模板管理'
			},
			children: [{
				path: 'manager',
				name: 'TemplateManager',
				component: () => import('./views/setting/template/TemplateManager'),
				meta: {
					title: '模板管理'
				}
			}, {
				path: 'design/:templateId(\\d+)?',
				name: 'TemplateDesign',
				component: () => import('./views/setting/template/TemplateDesign'),
				props: true,
				meta: {
					title: '模板设计'
				}
			}]
		},
		{
			path: '/permission-setting',
			name: 'PermissionSetting',
			component: () => import('./views/setting/PermissionSetting'),
			meta: {
				title: '权限设置'
			}
		},
		{
			path: '/personal',
			name: 'Personal',
			component: () => import('./views/personal/Index'),
			meta: {
				title: '个人设置'
			},
			children: [
				{
					path: 'personal-setting',
					name: 'PersonalSetting',
					component: () => import('./views/personal/PersonalSetting'),
					meta: {
						title: '个人设置'
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: () => import('./views/personal/ChangePassword'),
					meta: {
						title: '修改密码'
					}
				},
				{
					path: 'change-phone-number',
					name: 'ChangePhoneNumber',
					component: () => import('./views/personal/ChangePhoneNumber'),
					meta: {
						title: '修改手机'
					}
				},
				{
					path: 'binding-webchat',
					name: 'BindingWebchat',
					component: () => import('./views/personal/BindingWebchat'),
					meta: {
						title: '绑定微信'
					}
				}
			]
		},
		{
			path: '/account-book/detailed',
			name: 'DetailedAccounts',
			component: () => import('./views/accountbook/DetailedAccounts'),
			meta: {
				title: '明细账'
			}
		},
		{
			path: '/account-book/general-ledger',
			name: 'GeneralLedger',
			component: () => import('./views/accountbook/GeneralLedger'),
			meta: {
				title: '总账'
			}
		},
		{
			path: '/account-book/subject-balance',
			name: 'SubjectBalance',
			component: () => import('./views/accountbook/SubjectBalance'),
			meta: {
				title: '科目余额'
			}
		},
		{
			path: '/account-book/subject-summary',
			name: 'SubjectSummary',
			component: () => import('./views/accountbook/SubjectSummary'),
			meta: {
				title: '科目汇总'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-balance',
			name: 'AuxiliaryAccountingBalance',
			component: () => import('./views/accountbook/AuxiliaryAccountingBalance'),
			meta: {
				title: '辅助核算余额'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-detail',
			name: 'AuxiliaryAccountingDetail',
			component: () => import('./views/accountbook/AuxiliaryAccountingDetail'),
			meta: {
				title: '辅助核算明细账'
			}
		},
		{
			path: '/report',
			name: 'ReportList',
			component: () => import('./views/report/ReportList'),
			meta: {
				title: '报表'
			}
		},
		{
			path: '/report/view/:reportId(\\d+)',
			name: 'ReportView',
			props: true,
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '报表数据'
			}
		},
		{
			path: '/report/template',
			name: 'ReportTemplate',
			component: () => import('./views/report/template/TemplateList'),
			meta: {
				title: '报表模板'
			}
		},
		{
			path: '/report/template/form/:templateId(\\d+)',
			name: 'TemplateForm',
			props: true,
			component: () => import('./views/report/template/TemplateForm'),
			meta: {
				title: '模板编辑'
			}
		}
	]
});
